import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { ManageShippingAddressesCTA } from "./ctas";
export var UpdateAccountShippingAddressIA = function UpdateAccountShippingAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return CHANGE_YOUR_SHIPPING_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [USE_BUTTON_TO_UPDATE_ACCOUNT_SHIPPING_ADDRESS(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ManageShippingAddressesCTA(strictLocalize);
};
var CHANGE_YOUR_SHIPPING_ADDRESS = function CHANGE_YOUR_SHIPPING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "GXV7Mw",
    defaultMessage: [{
      "type": 0,
      "value": "Alterar o seu endereço de envio"
    }]
  });
};
var USE_BUTTON_TO_UPDATE_ACCOUNT_SHIPPING_ADDRESS = function USE_BUTTON_TO_UPDATE_ACCOUNT_SHIPPING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "3bgLFx",
    defaultMessage: [{
      "type": 0,
      "value": "Atualize o endereço de envio na sua conta utilizando o botão abaixo. Se quiser alterar o endereço de uma encomenda, contacte a marca diretamente."
    }]
  });
};